export default {
  setUploadedHomeworks(state, data) {
    state.uploadedHomeworks = data;
    state.isUploadedHomeworksSent = true;
  },

  setOfficeUploadedHomeworks(state, data) {
    state.officeUploadedHomeworks = data;
    state.isOfficeUploadedHomeworksSent = true;
  },

  removeUploadedHomework(state, data) {
    const index = state.uploadedHomeworks.files.map(homework => homework.id).indexOf(data);
    state.uploadedHomeworks.files.splice(index, 1);
  },

  clearUploadedHomeworks(state) {
    state.uploadedHomeworks = [];
    state.isUploadedHomeworksSent = false;
  },
};
